module.exports = __webpack_public_path__ + "img/650.28f3553f.gif";